import { createAction } from "typesafe-actions";
import { ConfirmDialogConfig } from "./types";

export const showConfirmDialog = createAction(
  "@confirm_dialog/SHOW_CONFIRM_DIALOG"
)<ConfirmDialogConfig>();
export const hideConfirmDialog = createAction(
  "@confirm_dialog/HIDE_CONFIRM_DIALOG"
)<void>();
